import type { StateObject } from "@eventr/native/navigation";

/**
 * The `ViewSpec.state` key `modalEntry` stamps onto a sheet's root view. Its own
 * module so `NativeToolbar` can read the flag without importing init.ts, which would
 * risk a cycle through the route registry and drag plugin init into the toolbar.
 */
export const MODAL_ROOT_STATE_KEY = "isModalRoot";

/**
 * Whether a view context's state marks it as a sheet's root. Only that root lacks
 * native back chrome; anything pushed inside the sheet gets a real back chevron.
 */
export function isModalRoot(state: unknown): boolean {
  return !!state && typeof state === "object" && (state as StateObject)[MODAL_ROOT_STATE_KEY] === true;
}

/** The `ViewSpec.state` key stamped onto an entry pushed as the root of a split's trailing column. */
export const TRAILING_ROOT_STATE_KEY = "isTrailingRoot";

/**
 * Whether a view context's state marks it as the first screen of a trailing column. Expanded, that
 * screen has no native back chrome; collapsed, it is nested over the list and has a back chevron.
 */
export function isTrailingRoot(state: unknown): boolean {
  return !!state && typeof state === "object" && (state as StateObject)[TRAILING_ROOT_STATE_KEY] === true;
}
